export const TOPICS = [
  {
    icon: "pen",
    color: "#2DD4BF",
    title: { it: "Scrittura", en: "Writing" },
    desc: {
      it: "Poesie, haiku e prose — dal romantico al politico. Il mio blog, La Sveglia e il Risveglio, è dove metto in ordine le urla e il silenzio.",
      en: "Poems, haiku and prose — from romantic to political. My blog, La Sveglia e il Risveglio, is where I put the shouts and the silence in order.",
    },
  },
  {
    icon: "flask",
    color: "#C9A227",
    title: { it: "Divulgazione scientifica", en: "Science communication" },
    desc: {
      it: "Smonto bufale e fake news — dai vaccini al 5G — con fonti vere e un po' di ironia. Il pensiero critico si allena, come un muscolo.",
      en: "I debunk hoaxes and fake news — from vaccines to 5G — with real sources and a bit of irony. Critical thinking is trained like a muscle.",
    },
  },
  {
    icon: "sparkles",
    color: "#9146FF",
    title: { it: "Magia e mentalismo", en: "Magic & mentalism" },
    desc: {
      it: "Prestigiatore e mentalista: il mio effetto Parole in Treno, in vendita su Hyde Store, si avvicina alla lettura del pensiero.",
      en: "Magician and mentalist: my effect Parole in Treno, on sale at Hyde Store, comes close to mind reading.",
    },
  },
  {
    icon: "book",
    color: "#E5484D",
    title: { it: "Insegnamento", en: "Teaching" },
    desc: {
      it: "Insegno tecniche di apprendimento: lettura semantica, memorizzazione e metodo di studio. Prima di sviluppare app, sviluppavo menti.",
      en: "I teach learning techniques: semantic reading, memorization and study methods. Before developing apps, I developed minds.",
    },
  },
];

export const ARTICLES = [
  {
    year: "2020", tag: 1, url: "https://lasvegliaeilrisveglio.com/2020/06/19/fastidiosamente-utile/",
    title: { it: "Fastidiosamente Utile", en: "Fastidiosamente Utile" },
    excerpt: {
      it: "Contro bufale e complotti: perché il metodo scientifico batte l'analfabetismo funzionale, con fonti vere e un po' di ironia.",
      en: "Against hoaxes and conspiracies: why the scientific method beats functional illiteracy, with real sources and a bit of irony.",
    },
  },
  {
    year: "2019", tag: 2, url: "https://lasvegliaeilrisveglio.com/2019/03/09/parole-in-treno/",
    title: { it: "Parole in Treno", en: "Parole in Treno" },
    excerpt: {
      it: "La storia del mio effetto di mentalismo: mesi di ritocchi fino alla pubblicazione su Hyde Store.",
      en: "The story of my mentalism effect: months of refinements up to its release on Hyde Store.",
    },
  },
  {
    year: "2019", tag: 3, url: "https://lasvegliaeilrisveglio.com/2019/03/08/quando-festeggeremo-la-parita/",
    title: { it: "Quando festeggeremo la parità?", en: "Quando festeggeremo la parità?" },
    excerpt: {
      it: "Riflessioni sulla Giornata Internazionale della Donna e sulla strada che resta da fare, insieme.",
      en: "Thoughts on International Women's Day and the road still ahead, together.",
    },
  },
  { year: "2019", tag: 0, url: "https://lasvegliaeilrisveglio.com/2019/02/15/percorsi/", title: { it: "Percorsi", en: "Percorsi" } },
  { year: "2019", tag: 0, url: "https://lasvegliaeilrisveglio.com/2019/02/14/ritrovarsi/", title: { it: "Ritrovarsi", en: "Ritrovarsi" } },
  { year: "2018", tag: 3, url: "https://lasvegliaeilrisveglio.com/2018/11/07/quella-strana-cosa-chiamata-amicizia/", title: { it: "Quella strana cosa chiamata amicizia", en: "Quella strana cosa chiamata amicizia" } },
  { year: "2018", tag: 3, url: "https://lasvegliaeilrisveglio.com/2018/05/19/la-mediocrita-non-e-uguale-per-tutti/", title: { it: "La mediocrità non è uguale per tutti", en: "La mediocrità non è uguale per tutti" } },
  { year: "2017", tag: 1, url: "https://lasvegliaeilrisveglio.com/2017/05/27/opinioni-vs-realta/", title: { it: "Opinioni vs Realtà", en: "Opinioni vs Realtà" } },
  { year: "2017", tag: 1, url: "https://lasvegliaeilrisveglio.com/2017/05/25/la-colpa-dei-vaccini/", title: { it: "La colpa dei vaccini", en: "La colpa dei vaccini" } },
];

export const BLOG_URL = "https://lasvegliaeilrisveglio.com";
